import clsx from 'clsx'
import type { Sport } from '../../types'

interface SportSelectorProps {
  selected: Sport | 'ALL'
  onChange: (sport: Sport | 'ALL') => void
  showAll?: boolean
}

const sports: { value: Sport | 'ALL'; label: string; color: string }[] = [
  { value: 'ALL', label: 'All', color: 'bg-gray-600' },
  { value: 'NFL', label: 'NFL', color: 'bg-nfl' },
  { value: 'NBA', label: 'NBA', color: 'bg-nba' },
  { value: 'MLB', label: 'MLB', color: 'bg-mlb' },
  { value: 'NHL', label: 'NHL', color: 'bg-nhl' },
  { value: 'MLS', label: 'MLS', color: 'bg-mls' },
]

export default function SportSelector({ selected, onChange, showAll = true }: SportSelectorProps) {
  const filteredSports = showAll ? sports : sports.filter(s => s.value !== 'ALL')

  return (
    <div className="flex flex-wrap gap-2">
      {filteredSports.map((sport) => (
        <button
          key={sport.value}
          onClick={() => onChange(sport.value)}
          className={clsx(
            'px-4 py-2 rounded-full text-sm font-medium transition-all',
            selected === sport.value
              ? `${sport.color} text-white shadow-md`
              : 'bg-white text-gray-600 border border-gray-300 hover:border-gray-400'
          )}
        >
          {sport.label}
        </button>
      ))}
    </div>
  )
}
